import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'

import { ReactComponent as CloseFilled } from '../assets/icons/close-filled.svg'
import { ReactComponent as CheckMark } from '../assets/icons/checkmark.svg'
import { ReactComponent as DownArrow } from '../assets/icons/chevron-down.svg'
import { getSessionsAvailableDay, getSessionsEditablePeriod, putSessions } from '../apis/session.ts'
import { dayEnumList } from '../assets/data.js'

export default function SessionEditCard({ semesterId, lesson, onStateChange, setSelectedCard }) {
  const { register, watch, setValue, handleSubmit } = useForm({
    defaultValues: {
      description: lesson.description,
      // week: lesson.week,
      dayOfWeek: lesson.dayOfWeek,
      period: lesson.period,
    },
  })

  /*************** useEffect **************/

  useEffect(() => {
    getSessionsAvailableDayApi()
    // getSessionsApi()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    getSessionsEditablePeriodApi()
    // eslint-disable-next-line
  }, [watch('dayOfWeek')])

  /*************** 가능한 요일 조회 API **************/
  const [availableDay, setAvailableDay] = useState()
  const getSessionsAvailableDayApi = async () => {
    const getSessionsAvailableDayResponse = await getSessionsAvailableDay({
      semesterId: semesterId,
      week: lesson.week,
    })

    if (getSessionsAvailableDayResponse.error) {
      console.log(getSessionsAvailableDayResponse)
      return
    } else {
      console.log(getSessionsAvailableDayResponse.data)
      setAvailableDay(getSessionsAvailableDayResponse.data)
    }
  }

  /*************** 수정 가능한 교시 조회 API **************/
  const [availablePeriod, setAvailablePeriod] = useState()
  const getSessionsEditablePeriodApi = async () => {
    const getSessionsEditablePeriodResponse = await getSessionsEditablePeriod({
      sessionId: lesson.id,
      week: lesson.week,
      day: watch('dayOfWeek'),
    })

    if (getSessionsEditablePeriodResponse.error) {
      console.log(getSessionsEditablePeriodResponse)
      return
    } else {
      // console.log(getSessionsEditablePeriodResponse.data)
      setAvailablePeriod(getSessionsEditablePeriodResponse.data)
    }
  }
  const onSubmit = async (data) => {
    // console.log(data)
    const putSessionsResponse = await putSessions(
      { sessionId: lesson.id },
      {
        description: data.description,
        week: lesson.week,
        dayOfWeek: data.dayOfWeek,
        period: data.period,
      },
    )
    if (putSessionsResponse.error) {
      console.log(putSessionsResponse.message)
      return
    } else {
      console.log(putSessionsResponse.result)
      onStateChange()
      setSelectedCard()
      //   location.reload()
    }
  }
  // console.log(watch())
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className='flex min-h-[90px] items-center justify-between rounded-16 border border-border-strong bg-fill-alternative px-20 py-16'>
        <div className='flex items-center gap-32'>
          <p className='shrink-0 border-r-[1px] border-solid border-border-default pr-12 text-body2-semibold text-primary-normal'>
            수정
          </p>
          <div className='flex items-center gap-20'>
            <div className='flex items-center gap-[14px]'>
              <p className='shrink-0 text-body3-medium text-label-default'>요일</p>
              <div className='relative min-w-[82px]'>
                {availableDay && (
                  <select
                    {...register('dayOfWeek')}
                    className={`select_sm peer w-full default:text-label-disable`}
                  >
                    {availableDay?.map((dayItem, dayIndex) => (
                      <option key={dayIndex} value={dayItem}>
                        {dayEnumList[dayItem]}
                      </option>
                    ))}
                  </select>
                )}
                <DownArrow className='pointer-events-none absolute right-16 top-8 cursor-pointer fill-label-default peer-disabled:fill-label-disable' />
              </div>
            </div>
            <div className='flex items-center gap-[14px]'>
              <p className='shrink-0 text-body3-medium text-label-default'>교시</p>
              <div className='relative min-w-[82px]'>
                {availablePeriod && (
                  <select
                    {...register('period')}
                    className={`select_sm peer w-full default:text-label-disable`}
                  >
                    {availablePeriod?.map((periodItem, periodIndex) => (
                      <option key={periodIndex} value={periodItem}>
                        {periodItem}
                      </option>
                    ))}
                  </select>
                )}
                <DownArrow className='pointer-events-none absolute right-16 top-8 cursor-pointer fill-label-default peer-disabled:fill-label-disable' />
              </div>
            </div>
            <div className='flex items-center gap-[14px]'>
              <p className='shrink-0 text-body3-medium text-label-default'>설명 (선택)</p>
              <div className='relative'>
                <input
                  {...register('description', {
                    maxLength: 20,
                  })}
                  className='input_sm min-w-[270px]'
                  placeholder='차시를 구분할 수 있는 설명을 작성해주세요'
                  type='text'
                  maxLength='20'
                />
                {watch('description') && (
                  <button
                    className='absolute right-8 top-8 cursor-pointer'
                    onClick={() => setValue('description', '')}
                  >
                    <CloseFilled />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <button className='button_solid_primary_sm gap-4 fill-inverse-label' type='submit'>
          <CheckMark />
          <p>수정 완료</p>
        </button>
      </div>
    </form>
  )
}
